export default __webpack_public_path__ + "static/media/2298.9a6d9501.png";